// FUNÇÕES/MÓDULOS SITE
import sendForm from './modules/sendForm';
import changeCities from './modules/Utils/changeCities';

changeCities();
sendForm();